var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundedArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.1752V6.8252C8 6.54187 8.1 6.3042 8.3 6.1122C8.5 5.9202 8.73333 5.82453 9 5.8252C9.08333 5.8252 9.171 5.83753 9.263 5.8622C9.355 5.88687 9.44233 5.92453 9.525 5.9752L17.675 11.1502C17.825 11.2502 17.9377 11.3752 18.013 11.5252C18.0883 11.6752 18.1257 11.8335 18.125 12.0002C18.1243 12.1669 18.087 12.3252 18.013 12.4752C17.939 12.6252 17.8263 12.7502 17.675 12.8502L9.525 18.0252C9.44167 18.0752 9.35433 18.1129 9.263 18.1382C9.17167 18.1635 9.084 18.1759 9 18.1752C8.73333 18.1752 8.5 18.0792 8.3 17.8872C8.1 17.6952 8 17.4579 8 17.1752Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedArrow);
export default __webpack_public_path__ + "static/media/rounded-arrow.870c2984c013a16ebac56b05121445e2.svg";
export { ForwardRef as ReactComponent };